// Значение в формате datetime-local: "YYYY-MM-DDTHH:mm", локальное время.
const VALUE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

export const padTimePart = (value: number): string =>
  value.toString().padStart(2, "0");

const pad = padTimePart;

export const parseDateTimeValue = (value: string): Date | null => {
  const match = VALUE_PATTERN.exec(value);
  if (!match) return null;
  const [year, month, day, hours, minutes] = match.slice(1).map(Number);
  return new Date(year, month - 1, day, hours, minutes);
};

export const formatDateTimeValue = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
  `T${pad(date.getHours())}:${pad(date.getMinutes())}`;

export const formatDisplayDateTime = (date: Date): string =>
  `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ` +
  `${pad(date.getHours())}:${pad(date.getMinutes())}`;
